<script setup lang="ts">
import { computed } from 'vue'
import { UnionColorKeys } from '@/types/global'
import { findColorValue } from '@/utils/style'

const props = withDefaults(
  defineProps<{
    size?: 'large' | 'normal' | 'small' | 'xLarge' | 'huge'
    iconColor?: UnionColorKeys | 'currentColor'
    iconName: string
  }>(),
  {
    size: 'normal',
    iconColor: 'currentColor',
  }
)
const svgSizeMap = {
  huge: 24,
  xLarge: 22,
  large: 16,
  normal: 14,
  small: 12,
}

const iconColorValue = computed(() =>
  props.iconColor === 'currentColor' ? props.iconColor : findColorValue(props.iconColor)
)
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="svgSizeMap[props.size]"
    :height="svgSizeMap[props.size]"
    viewBox="0 0 24 24"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g :fill="iconColorValue">
      <slot />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
